module.exports = __webpack_public_path__ + "static/media/suopeibaodan1.c36b0776.png";